module.exports = __webpack_public_path__ + "img/folder-dark-green.3a657bd4.svg";